import { create } from "zustand";
import { AuthToken, CalendarView, User } from "../types";
import { axios } from "../utils";

type State = {
  authToken: AuthToken | null;
  setAuthToken: (authToken: AuthToken | null) => void;
  user: User | null;
  setUser: (user: User | null) => void;
  calendarView: CalendarView;
  setCalendarView: (calendarView: CalendarView) => void;
};

const useStore = create<State>((set) => ({
  authToken: JSON.parse(
    localStorage.getItem("accessToken") || "null",
  ) as AuthToken | null,
  setAuthToken: (authToken: AuthToken | null) => {
    if (authToken === null) {
      localStorage.removeItem("accessToken");
      axios.defaults.headers.common["Authorization"] = undefined;
    } else {
      localStorage.setItem("accessToken", JSON.stringify(authToken));
      axios.defaults.headers.common["Authorization"] =
        `${authToken.tokenType} ${authToken.accessToken}`;
    }

    return set((state) => ({
      ...state,
      authToken,
    }));
  },
  user: null,
  setUser: (user: User | null) => set((state) => ({ ...state, user })),
  calendarView: (localStorage.getItem("calendarView") as CalendarView) || "d",
  setCalendarView: (calendarView: CalendarView) => {
    localStorage.setItem("calendarView", calendarView);

    return set((state) => ({
      ...state,
      calendarView,
    }));
  },
}));

export default useStore;
